<template>
    <DModal
        :show="showModal"
        :title="__('tools.testing.snapshots.delete.modal.title')"
        :message="__('tools.testing.snapshots.delete.modal.message', {'snapshot': displayName ?? item})"
        is-confirm
        is-error
        @close="close"
        @confirm="confirm"
    />
</template>

<script setup>

import { __ } from '~@/Composables/translation'
import { ref } from 'vue'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    item: {
        type: String,
        default: ''
    },
    displayName: {
        type: String,
        default: ''
    }
})

const itemRef = ref(props.item)
const emit = defineEmits(['close', 'confirm'])

function confirm () {
    emit('confirm', itemRef.value)
}

function close () {
    emit('close')
}
</script>
